import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setHours(24, 0, 0, 0);
  const remaining = Math.max(0, tomorrow.getTime() - now.getTime());
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    day: new Intl.DateTimeFormat('es-AR', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Información sobre la oferta disponible hoy" className="mt-4 overflow-hidden rounded-2xl border border-primary/60 bg-ink px-4 py-4 text-surface shadow-offer ring-1 ring-primary/15 sm:px-5 sm:py-4" data-id="element-237" data-mp="e8jn5toohelx">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-238" data-mp="n9q4u632cvgr">
        <div className="min-w-0" data-id="element-239" data-mp="3voi23t686e50">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-pink-light/50 bg-pink/15 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-pink-light" data-id="element-240" data-mp="3rmwscgozmfz1">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-241" data-mp="9ai0yzvygz68" />
            OFERTA DISPONIBLE HOY
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-surface/65" data-id="element-242" data-mp="3cx8op8tc3585">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-surface/85" data-id="element-243" data-mp="37xvzwiiwjo2x">La promoción de hoy cierra a medianoche.</p>
        </div>

        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="polite" data-id="element-244" data-mp="1btetxe0wdaag">
          <Clock3Icon className="hidden h-5 w-5 text-primary-soft sm:block" aria-hidden="true" data-id="element-245" data-mp="1gsrjw7n2exh9" />
          <TimeUnit value={offerTime.hours} label="HS" data-id="element-246" data-mp="1lm43228z6c2m" />
          <span className="pb-4 font-display text-2xl font-bold text-pink-light" aria-hidden="true" data-id="element-247" data-mp="1qkotj9yfdhdv">:</span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-248" data-mp="sxospt0sghxm" />
          <span className="pb-4 font-display text-2xl font-bold text-pink-light" aria-hidden="true" data-id="element-249" data-mp="xvqamamhab7i">:</span>
          <TimeUnit value={offerTime.seconds} label="SEG" data-id="element-250" data-mp="12v2wot5ize91" />
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 border-t border-surface/10 pt-3 text-center text-xs text-surface/65 sm:justify-start" data-id="element-251" data-mp="12x76tsu0p9hr">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-252" data-mp="2e9811n9nhq4w" />
        <span data-id="element-253" data-mp="2iajvq77dt1jy">Revisá la oferta de hoy antes de que termine.</span>
      </div>
    </aside>;
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-254" data-mp="2nxuw7ehg9t0">
      <span className="font-display text-3xl font-bold leading-none text-pink-light sm:text-4xl" data-id="element-255" data-mp="3u0seu2mpzdbw">{value}</span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-surface/60" data-id="element-256" data-mp="3p30nb9pzlt88">{label}</span>
    </div>;
}